import { render, staticRenderFns } from "./addPenaltyRule.vue?vue&type=template&id=2107d688&scoped=true&"
import script from "./addPenaltyRule.vue?vue&type=script&lang=ts&"
export * from "./addPenaltyRule.vue?vue&type=script&lang=ts&"
import style0 from "./addPenaltyRule.vue?vue&type=style&index=0&id=2107d688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107d688",
  null
  
)

export default component.exports